<template>
  <!--TODO: Remove this once Odoo stops sending batterydegradation values for quotes without a battery-->
  <table v-if="quote && country === 'be'" class="table mb-5">
    <thead>
      <tr>
        <th class="text-left" scope="col" v-dynamic-content:batteries_overview_title></th>
        <th></th>
      </tr>
    </thead>
    <tbody>   
      <tr v-if="quote.detailOverview.batteryCapacity">
        <td class="text-left" v-dynamic-content:batteries_overview_battery_capacity></td>
        <td class="text-right">{{ quote.detailOverview.batteryCapacity | formatKwh(1) }}</td>
      </tr>
      <tr v-if="quote.detailOverview.batteryDegradation">
        <td class="text-left" v-dynamic-content:batteries_overview_battery_degradation></td>
        <td class="text-right">
          {{ quote.detailOverview.batteryDegradation | formatPercentage(2) }}
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'DetailBatteryInformation',
  props: ['quote'],
  computed: {
    country() {
      return this.$store.getters.country}
  }
}
</script>
